import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { Offer } from '../../../types/billing';
import { BillingCard } from '../../billing';
import { Plan } from '../../../types/billing'
import { CLOUDPAYMENTS_PUBLIC_ID_DEV } from '../../../constants/billing';

declare global {
  interface Window {
    ymGlobal: any;
  }
}

const BillingPage: React.FC = () => {
  const { user, plans } = useSelector((state: RootState) => state.user);

  let sorted_plans: Plan[] = JSON.parse(JSON.stringify(plans))
  const compare = (a: Plan, b: Plan) => {
    if (a.id > b.id) return 1;
    if (a.id < b.id) return -1;
    return 0;
  }
  sorted_plans.sort(compare);

  const handleSubscribe = ({ id, amount, name, currency }: Offer) => {

    if (!amount) {
      window.open('https://www.copymonkey.app/beta', '_blank', 'noopener,noreferrer');
      return;
    }

    if (!user) return;

    //@ts-ignore
    const widget = new cp.CloudPayments({ googlePaySupport: false });
    widget.pay('charge',
      {
        publicId: CLOUDPAYMENTS_PUBLIC_ID_DEV,
        description: `Оплата пакета ${name}`,
        amount: amount,
        currency: currency,
        accountId: user.id,
        email: user.email,
        skin: 'classic', //дизайн виджета (необязательно) mini, modern, classic
        autoClose: 3,
        data: {
          product_id: id,
        }
      },
      {
        onSuccess: function (options: any) {
          console.log('onSuccess:', options);

          if (window.ymGlobal) {
            window.ymGlobal(90338500, 'reachGoal', 'billing_success');
          }

        },
        onFail: function (reason: any, options: any) {
          console.log('onFail:', { reason, options });

          if (window.ymGlobal) {
            window.ymGlobal(90338500, 'reachGoal', 'billing_failed');
          }

        },
        onComplete: function (paymentResult: any, options: any) {
          console.log('onComplete:', { paymentResult, options });
        },
      }
    );
  };



  return (
    <Stack
      gap={'40px'}
      sx={{
        p: {
          mobile: '10px',
          tablet: '20px',
          laptop: '40px',
        },
      }}
    >

      <Stack
        display={'grid'}
        gap={'20px'}
        gridTemplateColumns={{
          mobile: '1fr',
          tablet: '1fr 1fr',
          laptop: 'repeat(4, 1fr)',
        }}
      >
        {sorted_plans.map((plan) => {
          return (
            <BillingCard
              key={plan.id}
              {...plan}
              price={plan.amount}
              isActive={plan.id === '002'}
              onSubscribe={() => handleSubscribe({ id: plan.id, name: plan.name, amount: plan.amount, currency: plan.currency })}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default BillingPage;
